import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { CopyableThrowable1mvc99jcyvivf as CopyableThrowable } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Debug.common.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FrameTooBigExceptionClass;
function FrameTooBigException() {
  if (FrameTooBigExceptionClass === VOID) {
    class $ extends Exception() {
      constructor(frameSize, cause) {
        return new.target.new_io_ktor_websocket_FrameTooBigException_7tb0yi_k$(frameSize, cause);
      }
      static new_io_ktor_websocket_FrameTooBigException_7tb0yi_k$(frameSize, cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.new_kotlin_Exception_bock1m_k$(cause);
        captureStack($this, $this.$throwableCtor_2);
        $this.frameSize_1 = frameSize;
        delete $this.message;
        return $this;
      }
      get_message_h23axq_k$() {
        var sizeSuffix = this.frameSize_1 >= 0n ? ': ' + this.frameSize_1.toString() : '';
        return 'Frame is too big' + sizeSuffix;
      }
      createCopy_mmw9ld_k$() {
        return FrameTooBigException().new_io_ktor_websocket_FrameTooBigException_7tb0yi_k$(this.frameSize_1, this);
      }
      get message() {
        return this.get_message_h23axq_k$();
      }
    }
    initMetadataForClass($, 'FrameTooBigException', VOID, VOID, [CopyableThrowable()]);
    FrameTooBigExceptionClass = $;
  }
  return FrameTooBigExceptionClass;
}
//region block: exports
export {
  FrameTooBigException as FrameTooBigException1rgdafsgu31sm,
};
//endregion

//# sourceMappingURL=FrameTooBigException.mjs.map
